// extracted by mini-css-extract-plugin
export default {"with-svg-core-badge":"_2qYj8","withSvgCoreBadge":"_2qYj8"};